import { render, staticRenderFns } from "./ClerkLogin.vue?vue&type=template&id=6a20715c&scoped=true"
import script from "./ClerkLogin.vue?vue&type=script&lang=js"
export * from "./ClerkLogin.vue?vue&type=script&lang=js"
import style0 from "./ClerkLogin.vue?vue&type=style&index=0&id=6a20715c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a20715c",
  null
  
)

export default component.exports